<template>
  <div>
    <h3>{{ title }}</h3>
    <b-table
      small
      hover
      outlined
      foot-clone
      :items="items"
      :tbody-tr-class="rowClass"
      head-variant="light"
      :fields="fields"
    >
      <template v-slot:foot()="data"></template>
      <template v-slot:foot(net_kilograms)="data">
        <span>{{ footers.net_kilograms }}</span>
      </template>
      <template v-slot:foot(gross_kilograms)="data">
        <span>{{ footers.gross_kilograms }}</span>
      </template>
      <template v-slot:foot(quantity)="data">
        <span>{{ footers.quantity }}</span>
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <a
            v-if="data.item.exportable"
            href="#"
            title="Ver detalles"
            class="mx-1 fa fa-lg fa-angle-down text-info"
            @click.prevent="data.toggleDetails"
          >
          </a>
          <print-modal v-show="table_type == 1" :pallet_id="data.item.pallet_id"></print-modal>

          <a
            target="_blank"
            href="#"
            @click.prevent="deleteRow(data.item, data.index)"
            class="mx-1 fa fa-lg fa-close text-danger"
            title="Eliminar"
          ></a>
        </span>
      </template>
      <template v-slot:cell(selling_format)="data">
        <span>
          {{ sellingFormat(data.item.units_per_container, data.item.kg_per_unit) }}
        </span>
      </template>

      <template #row-details="row">
        <b-card no-body>
          <b-row class="my-2">
            <b-col sm="3" class="text-sm-right"><b>Especificaciones:</b></b-col>
            <b-col>{{ row.item.string_specs }}</b-col>
          </b-row>

          <b-row class="mb-2" v-for="(field, index) in row.item.custom_fields" :key="index">
            <b-col sm="3" class="text-sm-right"
              ><b>{{ index | labelize }}:</b></b-col
            >
            <b-col>{{ field }}</b-col>
          </b-row>
        </b-card>
      </template>
      <template v-slot:cell(product_name)="data">
        <span v-if="data.item.is_devolution">
          {{ data.item.product_name }}
          <b-badge :variant="getBadge(data.item.is_devolution)"> DEVOLUCIÓN</b-badge>
        </span>
        <span v-else>
          {{ data.item.product_name }}
          <b-badge variant="primary"> {{ data.item.product_type.name }}</b-badge>
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
import PrintModal from "../procesos/PrintModal";
import labelize from "@/assets/js/utils";

export default {
  name: "ContentTable",
  components: {
    PrintModal
  },
  props: {
    table_type: {
      type: Number,
      default: 0
    },
    items: {
      type: [Array, Object],
      default: []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    footers: {
      type: [Object, Function],
      default: () => {
        return {
          net_kilograms: 0,
          gross_kilograms: 0,
          quantity: 0
        };
      }
    }
  },
  filters: {
    labelize(value) {
      return labelize(value);
    }
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.waste) return "text-danger";
    },
    deleteRow(item, index) {
      this.$emit("delete-row", {
        table: this.table_type,
        item: item,
        index: index
      });
      // this.$store.commit('bagnoProcessModule/deleteRow', a);
    },
    sellingFormat(units, kg) {
      return units === 0 ? "no aplica" : units + "Un x " + kg + "Kg";
    },
    getBadge(condition) {
      return condition ? "warning" : "secondary";
    }
  },
  data() {
    return {
      pallet_id: null
    };
  }
};
</script>

<style scoped></style>
